const newArchiveRouter = {
  path: '/teachingInfo',
  name: 'TeachingInfo',
  redirect: '/teachingInfo/',
  component: () => import('@/components/homepage/homepageTop.vue'),
  children: [
    {
      path: '/',
      name: 'archiveIndex',
      meta: {
        title: '',
        hideHead: true,
        type: 'login'
      },
      component: () => import('@/views/mine/homepage/subjects.vue')
    },
    {
      path: 'archiveInfo',
      name: 'ArchiveInfo',
      meta: {
        title: '',
        hideHead: true,
        type: 'login'
      },
      component: () => import('@/views/mine/homepage/archive.vue')
    },
    {
      path: 'archive_lesson',
      name: 'ArchiveLesson',
      meta: {
        title: '',
        hideHead: true,
        type: 'login'
      },
      component: () => import('@/views/mine/homepage/archiveLesson.vue')
    }
  ]
}
export default newArchiveRouter
